import type React from 'react';

import { Stack } from '@mui/material';
import { Carousel } from '@realadvisor/carousel';
import { Image } from '@realadvisor/image';

import { NoPhotosPlaceholder } from '@modules/_shared/components/NoPhotoPlaceholder';

type CardCarouselProps = {
  images: { id: string; url: string }[];
  topOverlayContent: React.ReactNode;
  bottomOverlayContent: React.ReactNode;
};

export const CardCarousel: React.FC<CardCarouselProps> = ({
  images,
  topOverlayContent,
  bottomOverlayContent,
}) => {
  const imageRatio = 10 / 16;

  return (
    <div css={{ position: 'relative' }}>
      {images.length === 0 ? (
        <NoPhotosPlaceholder ratio={imageRatio} />
      ) : (
        <Carousel
          media={{
            gap: 0,
            itemsOnScreen: 1,
            aspectRatio: imageRatio,
          }}
        >
          {images.map(item => {
            const options = { w: 700, c: 'fill', f: 'jpg' } as const;
            return (
              <Image
                key={item.id}
                css={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
                loading={'lazy'}
                options={options}
                src={item.url}
              />
            );
          })}
        </Carousel>
      )}
      <Stack
        direction="row"
        sx={{
          gap: 1,
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
          position: 'absolute',
          top: 10,
          left: 10,
          zIndex: 1,
          right: 10,
        }}
      >
        {topOverlayContent}
      </Stack>
      <Stack
        direction="row"
        sx={{
          gap: 1,
          flexWrap: 'nowrap',
          justifyContent: 'space-between',
          position: 'absolute',
          bottom: 10,
          left: 10,
          zIndex: 1,
          right: 10,
        }}
      >
        {bottomOverlayContent}
      </Stack>
    </div>
  );
};
